import { Button, Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

const headers = ["Duration"];

// const items = [
//   {
//     id: 1,
//     Duration: "1 Months",
//   },
// ];

function Duration() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);

  // const [durationTypeDD, setDurationTypeDD] = useState([]);
  // const [durationtype, setDurationtype] = useState();
  // const [durationvalue, setDurationvalue] = useState();

  const navigate = useNavigate();

  // const onOpen = () => {
  //   navigate("/durationmanage", {
  //     state: {
  //       action: "duration-edit",
  //       data: selectedItem?.item?.data,
  //     },
  //   });
  // };

  const onNew = async () => {
    navigate("/durationmanage", {
      state: {
        action: "duration-add",
        data: {},
      },
    });
    // setIsLoading(true);
    // const res = await api.addDuration({
    //   durationtype,
    //   active: true,
    //   hide: false,
    //   durationvalue,
    // });

    // setIsLoading(false);
    // toaster.create({
    //   title: res?.response?.data?.message || res?.data?.message || res?.message,
    //   type: res?.status === 200 ? "success" : "error",
    // });

    // if (res?.status === 200) {
    //   getList();
    // }
  };

  // const onSave = async () => {
  //   setIsLoading(true);
  //   const res = await api.updateDuration({
  //     durationtype,
  //     active: true,
  //     hide: false,
  //     durationvalue,
  //     durationid: selectedItem?.item?.data?.durationid,
  //   });
  //   setIsLoading(false);

  //   toaster.create({
  //     title: res?.response?.data?.message || res?.data?.message || res?.message,
  //     type: res?.status === 200 ? "success" : "error",
  //   });

  //   if (res?.status === 200) {
  //     getList();
  //   }
  // };

  // const onDelete = async () => {
  //   setIsLoading(true);
  //   const res = await api.deleteDuration({
  //     durationid: selectedItem?.item?.data?.durationid,
  //   });
  //   setIsLoading(false);
  //   toaster.create({
  //     title: res?.response?.data?.message || res?.data?.message || res?.message,
  //     type: res?.status === 200 ? "success" : "error",
  //   });

  //   if (res?.status === 200) {
  //     getList();
  //   }
  // };

  const getList = async (data) => {
    setIsLoading(true);

    return api
      .getPurchasedurationAll({
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);

        if (res?.status === 200) {
          console.log(res.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.durationid) {
            const l = res.data.map((item) => ({
              id: item.durationid,
              covertype: `${item.durationvalue} ${item.durationtype}`,
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }

          // if (res?.data?.settingtype === "VAT") {
          // setSettingvalue(res?.data?.settingvalue);
          // }
        } else {
          setList([]);

          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  // const onChangeDurationDD = (data) => {
  //   console.log("vvvvvv", data?.list[0]?.selected);
  //   setDurationTypeDD(data?.list ? [...data?.list] : []);
  //   // setDurationtype(data?.item?.label || "");
  // };

  // const getDurationTypeDD = () => {
  //   let list = [
  //     {
  //       id: "Months",
  //       label: "Months",
  //       value: "Months",
  //       data: {
  //         durationtype: "Months",
  //       },
  //     },
  //   ];

  //   onChangeDurationDD({
  //     index: 0,
  //     item: list[0],
  //     list,
  //   });
  // };

  const onSelectItm = (data) => {
    console.log("selected item d id =", data?.item?.data?.durationtype);

    navigate("/durationmanage", {
      state: {
        action: "duration-edit",
        data: data?.item?.data,
      },
    });

    // setSelectedItem(data);

    // setDurationvalue(data?.item?.data?.durationvalue);

    // let list2 = JSON.parse(JSON.stringify(durationTypeDD));
    // let index;
    // let item;
    // if (list2 && list2[0]) {
    //   list2 = list2.map((a, idx) => {
    //     if (a?.data?.durationtype === data?.item?.data?.durationtype) {
    //       a.selected = true;
    //       item = a;
    //       index = idx;
    //     } else {
    //       a.selected = false;
    //     }
    //     return a;
    //   });
    // }

    // onChangeDurationDD({
    //   index,
    //   item,
    //   list: list2,
    // });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      // searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cb = async () => {
      await getList();
      // getDurationTypeDD();
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Duration"} isLoading={isLoading} />
      <Flex wrap={"wrap"} justify={"space-between"} gap={"1rem"} mb={"1rem"}>
        {/* <InputComp
          type={"number"}
          label={"Duration"}
          value={durationvalue}
          onChange={setDurationvalue}
        /> */}
        {/* <InputComp
          type="dropdown"
          // label={"Branch"}
          items={durationTypeDD}
          onChange={onChangeDurationDD}
          // placeholder={"Select Branch"}
          // required={true}
        /> */}

        {/* <InputComp type={'dropdown'} items={durationTypeDD} onChange={onChangeDurationDD} /> */}
        {/* <Flex flex={1} /> */}
        {/* <Button variant="outline" onClick={onSave} disabled={!selectedItem}>
          Save
          </Button> */}
        {/* <Button variant="outline" onClick={onDelete} disabled={!selectedItem}>
          Delete
        </Button> */}
        <Flex />
        <Flex gap={"1rem"}>
          {/* <Button variant="outline" onClick={onOpen} disabled={!selectedItem}>
            Open
          </Button> */}
          <Button variant="outline" onClick={onNew}>
            New
          </Button>
        </Flex>
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Duration;
